import type { UntypedFormControl } from '@angular/forms';

import moment from 'moment-timezone';

export function timeValidator(control: UntypedFormControl): { time: true } | null {
  return control.value !== '' && moment(control.value, 'LT', true).isValid()
    ? null
    : { time: true };
}
